import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { connect } from 'react-redux';

const PrivateRoute = ({ component: Component, isAuthenticated, ...rest }) =>
    <Route {...rest} render={(props) =>
        isAuthenticated === true ?
            <Component {...props} /> :
            <Redirect to="/" />
    } />

PrivateRoute.propTypes = {
    isAuthenticated: PropTypes.bool
};

const mapStateToProps = ({ authentication }) => ({
    isAuthenticated: !!authentication.accessToken
})

const enhance = connect(mapStateToProps);

export default enhance(PrivateRoute);


// WEBPACK FOOTER //
// ./src/components/routes/components/PrivateRoute.js